module.exports = __webpack_public_path__ + "img/5.84f3eda8.jpeg";